<div style="padding: 24px 24px 0">
  <p>Kiválasztott eredmény: <b>{{resultText}}</b></p>
</div>
<mat-dialog-content style="width: 440px; max-width: 90vw;">
  <mat-form-field style="width: 100%;">
    <mat-label>Megjegyzés az eredményhez</mat-label>
    <textarea matInput
              #message
              [escapeAwareMaxLength]="1000"
              [formControl]="textFormControl"
              cdkTextareaAutosize
              cdkAutosizeMinRows="4"
              cdkAutosizeMaxRows="16"></textarea>
    <mat-error *ngIf="textFormControl.hasError('required')">
      Kötelező mező
    </mat-error>
    <mat-hint align="end">{{message.value | escapeAwareCharCount}} / 1000</mat-hint>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onNoClick()">Mégsem</button>
  <button mat-stroked-button (click)="onSendClick()" [disabled]="textFormControl.hasError('required')">
    Mehet
  </button>
</mat-dialog-actions>
